export default __webpack_public_path__ + "static/media/refresh-icon.450003f0.svg";